import '../node_modules/leaflet/dist/leaflet.js';
import '../node_modules/leaflet-search/dist/leaflet-search.src.js';
import '../node_modules/leaflet.markercluster/dist/leaflet.markercluster.js';
import { identity } from 'svelte/internal';

export function createMap(mapId, geoJsonData, pageURL, apiURL, ambiti, placeDetailPageURL) {
    const tiles = L.tileLayer(
        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
        maxZoom: 18,
        attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }
    );

    const map = L.map(mapId, {
        scrollWheelZoom: false,
        fullscreenControl: {
            pseudoFullscreen: false
        }
    }).setView([40.02, 9.03], 8).addLayer(tiles);

    const markers = L.markerClusterGroup();

    const geoJsonLayer = L.geoJson(geoJsonData, {
        onEachFeature: function (res, layer) {
            layer.on('click', (async a => {
                createPopup(layer, res, pageURL, apiURL, ambiti, placeDetailPageURL);
            }))
        },
    });
    markers.addLayer(geoJsonLayer);
    map.addLayer(markers);
    map.fitBounds(markers.getBounds());

    createControlSearch(map, markers, pageURL, apiURL, ambiti, placeDetailPageURL);
}

async function createMarkerDetailPane(res, pageURL, apiURL, ambiti, placeDetailPageURL) {
    const {map: ambito} = await fetchPointDetail(res.id, apiURL);
    const {address, placeName} = res.properties;
    const container = document.createElement('div');
    const heading = document.createElement('h6');
    const headingAnchor = document.createElement('a');
    headingAnchor.href = `${placeDetailPageURL}?id=${res.id}`;
    headingAnchor.innerText = address;
    headingAnchor.classList.add('text-decoration-none');
    headingAnchor.classList.add('text-primary');
    heading.appendChild(headingAnchor);
    container.appendChild(heading);
    if(!!ambito) {
        const ulList = document.createElement('div');
        ulList.classList.add('lista-ambito');
        Object.entries(ambito).forEach(([k, v]) => {
            const liElement = document.createElement('span');
            liElement.classList.add('element-ambito');
            const anchor = document.createElement('a');
            anchor.href = `${pageURL}?placeId=${res.id}&placeName=${placeName}&fc-subambito=${k}`;
            anchor.innerText = `${getTopicLabel(k, ambiti)}: `;
            anchor.classList.add(getClassByTopic(k));
            anchor.classList.add('text-decoration-none');
            anchor.classList.add('text-secondary');
            liElement.appendChild(anchor);
            liElement.insertAdjacentText('beforeend', v);
            ulList.appendChild(liElement);
        });
        container.appendChild(ulList);
    }

    return container;
}

async function fetchPointDetail(layerId, apiURL) {

    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Origin': '*'
    }

    const pointDetail = await fetch([apiURL, layerId].join('/'),
      {
        method: 'GET',
        headers: headers
      }).then(response => {
        if (response.ok) {
            return response.json();
        }
    }).catch(e => {
        console.error('Error while fetching data', e);
        return {map: null};
    });

    return await pointDetail;
}

function getTopicLabel(topic, topicMap) {
    const topicCode = `${topic}`.toLowerCase().replace(' ','_');
    
    return topicMap[topicCode] ?? topic;
}

function getClassByTopic(topic) {
    const topicCode = `${topic}`.toLowerCase().replace(' ','-');
    return `${topicCode}-color`;
}

async function createPopup(layer, res, pageURL, apiURL, ambiti, placeDetailPageURL) {
    if(!layer.getPopup()) {
        const popup = await createMarkerDetailPane(res, pageURL, apiURL, ambiti, placeDetailPageURL);
        layer.bindPopup(popup);
        layer.openPopup();
    }
}

function createControlSearch(map, markers, pageURL, apiURL, ambiti, placeDetailPageURL) {
    const controlSearch = new L.Control.Search({
		position:'topright',
        markerLocation:true,
		layer: markers,
		initial: false,
		zoom: 12,
        propertyName: 'address',
		marker: false,
        casesensitive: false,
        moveToLocation: function(latlng, title, map) {
  			map.setView(latlng, 18);
        }
	});

    controlSearch.on('search:locationfound', async function(e) {
        if(e.layer.getPopup()) {
            e.layer.openPopup();
        } else {
            createPopup(e.layer, e.layer.feature, pageURL, apiURL, ambiti, placeDetailPageURL);
        }
	});

    map.addControl(controlSearch);
}